import { render, staticRenderFns } from "./CommingSoon.vue?vue&type=template&id=5c66138e&"
import script from "./CommingSoon.vue?vue&type=script&lang=js&"
export * from "./CommingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports